//import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        ivaText: {
            textStyle: 'body-xsmall',
            fontWeight: 'regular',
            color: 'foreground.neutral.subtle',
        },
    },
    variants: {
        tile: {
            ivaText: {
                textStyle: 'body-xxsmall',
                fontWeight: 'regular',
                color: 'foreground.neutral.subtle',
                width: 'auto',
            },
        },
        OrderDetail: {
            ivaText: {
                width: 'auto',
                color: 'inherit',
            },
        },
        vatNoWrap: {
            ivaText: {
                whiteSpace: 'nowrap',
            },
        },
    },
    parts: ['ivaText'],
}
